import { render } from "./SalesReturnListPage.vue?vue&type=template&id=0a739efe&scoped=true&ts=true"
import script from "./SalesReturnListPage.vue?vue&type=script&lang=ts"
export * from "./SalesReturnListPage.vue?vue&type=script&lang=ts"

import "./SalesReturnListPage.vue?vue&type=style&index=0&id=0a739efe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a739efe"]])

export default __exports__